import { useEffect, useState } from "react";
import "./styles.css";
import { InputObject, OutputObject } from "../FormatDeep";

import { FormatChartData } from "../../../../components/recharts/functions";
import {
  lightenColor,
  ReMixChart,
} from "../../../../components/recharts/ReMixCharts";
import { ChartRecord, ChartType } from "../../../../models/chart_model";
import {
  fetchSnapshots,
  fetchTamData,
  fetchAuctionData,
} from "../../../../Rest_api/RestApi";
import { ExchangeColors } from "../../Exchange3/FormatData";
import FilterMenu from "../../../../components/FilterMenu";
import Loading from "../../../../components/Loading";
const INTERVAL = ["date", "product", "exchange"];
const EXCHANGES = ["IEX", "HPX", "PXIL", "DEEP"];
const PRODUCTS = [
  "DAM",

  "RTM",
  "GDAM",
  "RA",
  "DAC",
  "Daily",
  "Intra day",
  "Monthly",
  "Weekly",
  "HP Daily",
  "HP Monthly",
  "HP Intra Day",
  "HP DAC",
  "HP Weekly",
];

const GROUP_BY = ["exchange", "product", "type"];
const UNIT_KEYS = ["weighted_average_price", "total_volume_mwh"];

export const MarketAnalysis = ({
  dates,
}: {
  dates: { startDate: Date; endDate: Date }[];
}) => {
  const [snapshotData, setSnapshotData] = useState<ChartRecord[]>([]);
  //   const start_date = "2024-01-01";
  //   const end_date = "2024-01-05";
  const [tamData, setTamData] = useState<ChartRecord[]>([]);
  const [chartData, setChartData] = useState<ChartRecord[]>([]);
  const [selectedExchange, setSelectedExchange] = useState<string[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [groupBy, setGroupBy] = useState<string[]>(["type"]);
  const [selectedInterval, setSelectedInterval] = useState<string>("date");
  const [chartKeys, setChartKeys] = useState<{
    keys: string[];
    label: string[];
  }>({
    keys: [],
    label: [],
  });
  const [auctionData, setAuctionData] = useState<ChartRecord[]>([]);

  useEffect(() => {
    _handleChartDataChange();
  }, [
    snapshotData,
    tamData,
    selectedInterval,
    groupBy,
    selectedExchange,
    selectedProduct,
  ]);

  const _handleFetchingData = async (start_date: string, end_date: string) => {
    setIsLoading(true);
    const snapshots: ChartRecord[] = await fetchSnapshots(start_date, end_date);
    const tamData: ChartRecord[] = await fetchTamData(start_date, end_date);
    const auctionData = await fetchAuctionData({
      startDate: start_date,
      endDate: end_date,
    });
    // start_date,
    // end_date
    // );
    setAuctionData(auctionData.auctions);
    setSnapshotData(snapshots);
    setTamData(tamData);
    setIsLoading(false);
  };

  useEffect(() => {
    _handleFetchingData(
      dates[0].startDate
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"),
      dates[0].endDate
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-")
    );
  }, [dates]);
  const _handleChartDataChange = () => {
    let data = snapshotData
      .concat(tamData)
      .concat(
        ProcessAuctionData(
          auctionData as any,
          dates[0].startDate
            .toLocaleDateString("en-GB")
            .split("/")
            .reverse()
            .join("-"),
          dates[0].endDate
            .toLocaleDateString("en-GB")
            .split("/")
            .reverse()
            .join("-")
        )
      );
    if (selectedExchange.length > 0) {
      data = data.filter((d) => selectedExchange.includes(d.exchange));
    }
    if (selectedProduct.length > 0) {
      data = data.filter((d) => selectedProduct.includes(d.product));
    }

    const chartData = FormatChartData({
      keys: [selectedInterval],
      groupBy: groupBy,
      aggregationKeys: [],
      priceKey: "weighted_average_price",
      volumeKey: "total_volume_mwh",
      data: data,
    });
    console.log(chartData);
    setChartData(chartData.data as ChartRecord[]);
    setChartKeys({
      keys: chartData.keys,
      label: chartData.keysLabels,
    });
  };
  const _handleExchangeChange = (exchange: string) => {
    if (selectedExchange.includes(exchange)) {
      setSelectedExchange(selectedExchange.filter((e) => e !== exchange));
    } else {
      setSelectedExchange([...selectedExchange, exchange]);
    }
  };

  const _handleProductChange = (product: string) => {
    if (selectedProduct.includes(product)) {
      setSelectedProduct(selectedProduct.filter((e) => e !== product));
    } else {
      setSelectedProduct([...selectedProduct, product]);
    }
  };

  const _handleGroupByChange = (group: string) => {
    if (groupBy.includes(group)) {
      setGroupBy(groupBy.filter((e) => e !== group));
    } else {
      setGroupBy([...groupBy, group]);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="gas-page-container">
      <div className="side-filters-container text-nowrap">
        <div></div>
        <div className="side-filter-item">
          <h4>X-Axis</h4>
          {INTERVAL.map((interval) => {
            return (
              <p
                key={interval}
                onClick={() => {
                  if (interval == "date") {
                    setGroupBy(["exchange"]);
                  }
                  if (interval == "product") {
                    setGroupBy(["exchange"]);
                  }
                  if (interval == "exchange") {
                    setGroupBy(["product"]);
                  }
                  setSelectedInterval(interval);
                }}
                className={
                  "side-filter-subitem capitalize  " +
                  (selectedInterval === interval
                    ? "side-filter-subitem  side-filter-subitem-active"
                    : "")
                }
              >
                {interval}
              </p>
            );
          })}
        </div>
        <div className="side-filter-item">
          <h4>Exchanges</h4>
          {EXCHANGES.map((exchange) => {
            return (
              <p
                key={exchange}
                onClick={() => _handleExchangeChange(exchange)}
                className={
                  "side-filter-subitem  " +
                  (selectedExchange.includes(exchange)
                    ? "side-filter-subitem-active"
                    : "")
                }
              >
                {exchange}
              </p>
            );
          })}
        </div>
        <div className="side-filter-item">
          <h4>Products</h4>
          {PRODUCTS.map((product) => {
            return (
              <p
                key={product}
                onClick={() => _handleProductChange(product)}
                className={
                  "side-filter-subitem  " +
                  (selectedProduct.includes(product)
                    ? "side-filter-subitem-active"
                    : "")
                }
              >
                {product}
              </p>
            );
          })}
        </div>

        <FilterMenu
          title="Group By"
          showEmptySelected={false}
          items={GROUP_BY.filter(
            (value) => !selectedInterval.includes(value)
          ).filter(
            (value) =>
              !(
                value == "type" &&
                (selectedInterval.includes("product") ||
                  selectedInterval.includes("exchange"))
              )
          )}
          selectedItems={groupBy}
          onSelect={(string, index) => {
            _handleGroupByChange(string);
          }}
        />
      </div>

      <div className="flex flex-col w-full h-full">
        <div className="markeMonitoring-chart-container">
          <div className="markeMonitoring-chart">
            <ReMixChart
              data={chartData}
              chartContainerHeight="100vh"
              showSecondYAxis={true}
              // barCategoryGap={10}
              isTimeSlot={false}
              onlyTitle={true}
              barCategoryGap={8}
              showBrush={true}
              brushIndex={{
                startIndex: 0,
                endIndex: chartData.length > 15 ? 14 : chartData.length - 1,
              }}
              xLabel="Date"
              unit="MWh"
              yAxisLabel="Volume(MWh)"
              secondYAxisLabel="Price(INR)"
              legends={[
                ...chartKeys.keys
                  .map((key, index) => {
                    return {
                      dataKey: key + "_" + UNIT_KEYS[1],
                      type: ChartType.Bar,
                      name: chartKeys.label[index] + " Volume",
                      stroke: lightenColor(ExchangeColors[index], 20),
                    };
                  })
                  .flat(),
                ...chartKeys.keys
                  .map((key, index) => {
                    return {
                      dataKey: key + "_" + UNIT_KEYS[0],
                      type: ChartType.Line,
                      yAxisId: "right",
                      name: chartKeys.label[index] + " Price",
                      stroke: ExchangeColors[index],
                      // legendColor: ExchangeColors[index],
                    };
                  })
                  .flat(),
              ]}
              xDataKey={selectedInterval}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const calculateHoursBetween = (startTime: string, endTime: string): number => {
  const start = new Date(`1970-01-01T${startTime}Z`);
  const end = new Date(`1970-01-01T${endTime}Z`);
  let hours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
  return Math.round(hours * 100) / 100;
};
function ProcessAuctionData(
  inputData: InputObject[],
  startDate: string,
  endDate: string
): OutputObject[] {
  const outputData: OutputObject[] = [];

  // Convert the provided start and end date strings to Date objects
  const filterStartDate = new Date(startDate);
  const filterEndDate = new Date(endDate);
  // filterEndDate.setHours(23, 59, 59, 999); // Ensure end date includes the entire day

  for (const data of inputData) {
    // Parse the delivery start and end datetime
    const startDateTime = new Date(
      `${data.delivery_start_date}T${data.delivery_start_time}`
    );
    const endDateTime = new Date(
      `${data.delivery_end_date}T${data.delivery_end_time}`
    );

    // Adjust end time if it is "23:59:59" to "24:00:00" (next day)
    // if (data.delivery_end_time === "23:59:59") {
    //     endDateTime.setSeconds(endDateTime.getSeconds() + 1);
    // }

    // Loop through each day between the start and end dates
    let currentDateTime = new Date(startDateTime);
    // currentDateTime.setDate(currentDateTime.getDate() - 1)
    // endDateTime.setDate(endDateTime.getDate()  -  1)
    while (currentDateTime <= endDateTime) {
      // Check if the current date is within the provided range
      if (
        currentDateTime >= filterStartDate &&
        currentDateTime <= filterEndDate
      ) {
        const nextDate = new Date(currentDateTime);
        nextDate.setDate(currentDateTime.getDate() + 1);
        nextDate.setHours(0, 0, 0, 0);

        // Calculate hours for this day
        const dayEndTime = nextDate < endDateTime ? nextDate : endDateTime;
        const hoursInDay = calculateHoursBetween(
          data.delivery_start_time,
          data.delivery_end_time
        );

        // Calculate the total volume for this day
        const totalVolumeMwh = hoursInDay * data.allocated_quantity_mw;

        outputData.push({
          date: currentDateTime.toISOString().split("T")[0],
          month: currentDateTime.getMonth() + 1,
          exchange: data.exchange_type__name,
          type: "RA",
          total_volume_mwh: totalVolumeMwh,
          weighted_average_price: data.accepted_price_kwh,
          product: "RA",
        });
      }

      // Move to the next day
      currentDateTime.setDate(currentDateTime.getDate() + 1);
      currentDateTime.setHours(0, 0, 0, 0);
    }
  }

  // Sort by date
  outputData.sort((a, b) => a.date.localeCompare(b.date));

  return outputData;
}
